import { useCallback } from "react";

import {
  type AdStudioTemplatesQuery,
  useAdStudioTemplatesQuery,
} from "src/graphql";
import { selectAdStudioTemplateOptions } from "src/pages/ad-studio/components/ad-studio-template-selection";
import {
  type AdStudioTemplateCard,
  isAdStudioTemplateCard,
} from "src/pages/ad-studio/templates/types";

type AdStudioTemplateOptions = {
  /** False when no brand profile is chosen. */
  isEnabled: boolean;
  /** Undefined until the query resolves. */
  templates: AdStudioTemplateCard[] | undefined;
};

/**
 * Active Ads templates assigned to the brand profile, the shared source for
 * the template picker and the selected-template pills in the composer.
 */
export function useAdStudioTemplateOptions(
  brandProfileId: string | undefined,
): AdStudioTemplateOptions {
  const isEnabled = Boolean(brandProfileId);
  const selectOptions = useCallback(
    (data: AdStudioTemplatesQuery) =>
      selectAdStudioTemplateOptions(
        data.getCurrentAgenticSettingsEntities.filter(isAdStudioTemplateCard),
        brandProfileId ?? "",
      ),
    [brandProfileId],
  );
  const { data: templates } = useAdStudioTemplatesQuery(undefined, {
    enabled: isEnabled,
    select: selectOptions,
  });

  return { isEnabled, templates };
}
